export default {
    '2b-diagram10': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'Support for the Jacobite rebellion was driven by nostalgia for a lost world',
            'two': '<u>Wanted stability</u><br>A rural-based community that was stable and harmonious',
            'three': '<u>Wanted harmony</u><br>Free from the new competitive capitalism',
            'four': '<u>Wanted social order</u><br>A hierarchy of preordained places where inferiors obey superiors',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram10/i18n/en.js